import { Chip, Grid } from '@mui/material';
import { CodPositions, ScreenNames } from 'src/constants';
import { CodJourney } from 'src/constants/assemblyJourneys';

import { getScreenImageUrl } from './ScreenConfigSection.helper';
import { IScreenLayout, IScreenOption } from './ScreenConfigSection.interface';
import { StyledThumbnail } from './ScreenThumbnails.styled';

export const ScreenThumbnails = ({
  screenLayout,
  screenOptions,
  selectedState,
  codPosition,
}: {
  screenLayout: IScreenLayout;
  screenOptions: IScreenOption[];
  selectedState: CodJourney;
  codPosition: CodPositions;
}) => {
  return (
    <Grid container wrap="nowrap">
      {screenOptions.map((screen, index) => (
        <Grid
          container
          key={screen.value}
          width={'fit-content'}
          height={'fit-content'}
          flexDirection={'column'}
          alignItems={'center'}
          marginRight={
            screenOptions.length - 1 === index
              ? 0
              : screen.label === ScreenNames.PRESELL
              ? 10
              : 5
          }>
          <StyledThumbnail
            loading="lazy"
            src={getScreenImageUrl(
              screen.label as ScreenNames,
              index + 1,
              screenLayout,
              selectedState,
              codPosition,
            )}
            alt={screen.label}
          />
          <Chip
            label={screen.label}
            sx={{
              fontSize: '13px',
              width: 'fit-content',
              height: '25px',
              marginTop: '5px',
            }}
          />
        </Grid>
      ))}
    </Grid>
  );
};
